(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelUsuarios', PainelUsuarios);

  function PainelUsuarios() {
    return {
      restrict: 'E',
      controller: 'PainelUsuariosCtrl',
      controllerAs: 'usuarios',
      templateUrl: 'views/propriedade/painel-usuarios.html'
    };
  }
}());
